import { registerRootComponent } from 'expo';
import App from './App';

// Initialize Firebase background message handler
// This must be imported before App to register the handler
if (require('react-native').Platform.OS !== 'web') {
  require('./src/lib/notificationHandler');
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
